import { Controller } from "@hotwired/stimulus";

// Drives the "Apply to" segmented control on the widget variant form. A variant
// targets EITHER a split-test cohort OR a category OR all traffic — the three are
// mutually exclusive. Selecting a mode reveals only the relevant input and clears
// the others, so the exclusivity the model validates server-side is also
// structurally impossible to violate in the UI.
export default class extends Controller {
  static targets = [
    "modeBtn",
    "splitField",
    "categoryField",
    "splitInput",
    "categoryInput",
  ];

  connect() {
    const initial =
      this.hasCategoryInputTarget && this.categoryInputTarget.value.trim()
        ? "category"
        : this.hasSplitInputTarget && this.splitInputTarget.value.trim()
        ? "split"
        : "all";
    this.apply(initial);
  }

  choose(event) {
    event.preventDefault();
    this.apply(event.currentTarget.dataset.mode);
  }

  apply(mode) {
    if (mode !== "split" && this.hasSplitInputTarget) this.clearInput(this.splitInputTarget);
    if (mode !== "category" && this.hasCategoryInputTarget) this.clearInput(this.categoryInputTarget);

    if (this.hasSplitFieldTarget) this.splitFieldTarget.hidden = mode !== "split";
    if (this.hasCategoryFieldTarget) this.categoryFieldTarget.hidden = mode !== "category";

    this.modeBtnTargets.forEach((btn) => {
      const on = btn.dataset.mode === mode;
      btn.style.background = on ? "#FAECE7" : "transparent";
      btn.style.color = on ? "#712B13" : "";
      btn.style.fontWeight = on ? "500" : "400";
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  // Clear a field the chosen mode hides, dispatching the input/change events the dirty
  // tracker (shop_settings_controller) listens for — otherwise switching mode silently
  // leaves Save disabled. The value !== "" guard keeps the initial connect() pristine:
  // the hidden inputs are already empty then, so no event fires on load.
  clearInput(input) {
    if (input.value === "") return;
    input.value = "";
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
